import { Link } from 'react-router-dom'
import { TrophyIcon } from '@heroicons/react/24/outline'

export default function HomePage() {
  return (
    <div className="min-h-screen relative" style={{ backgroundColor: '#00573d' }}>
      {/* Background Image - scaled to width, centered vertically */}
      <div 
        className="absolute inset-0 bg-contain bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url(/railbirds-hero-bg.png)',
          backgroundColor: '#00573d'
        }}
      >
      </div>
      {/* Navigation */}
      <nav className="relative z-10 px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center">
              <TrophyIcon className="w-6 h-6 text-green-900" />
            </div>
            <h1 className="text-2xl font-bold text-white">Midwest Railbirds</h1>
          </div>
          <div className="space-x-4">
            <Link
              to="/login"
              className="text-white hover:text-yellow-300 transition-colors duration-200"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="bg-yellow-500 hover:bg-yellow-400 text-green-900 px-6 py-2 rounded-lg font-semibold transition-colors duration-200"
            >
              Join Club
            </Link>
          </div>
        </div>
      </nav>

    </div>
  )
}
